/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import apiClient from '@/utilities/api-client';
import { isEmpty } from '@/utilities/validation';
import logging from '@/utilities/telemetry';
import compileChangeObject from './compile-onboard-change-object';

const { logEvent, logException } = logging;

export default async ({
  changes: changeArray, getAdminConfigValue,
  getFeature, sharedData, rootOrgId,
}) => {
  if (isEmpty(changeArray)) return;
  const body = {
    ...compileChangeObject(changeArray, sharedData, getAdminConfigValue, getFeature),
  };

  try {
    await apiClient.post(`${rootOrgId}/onboard/`,
      body,
      {
        headers: {
          'cache-control': 'no-cache',
        },
      });
  } catch (e) {
    logEvent({
      eventName: 'onboarding_failed',
      message: 'Could not onboard the company',
    });
    logException({
      eventName: 'onboarding_failed',
      exception: e,
    });
    throw new Error(e);
  }
};
